import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  static values = { max: Number }

  connect() {
    this.max = parseInt(this.inputTarget.dataset.packageHoldQty, 10)
  }
  
  increment() {
    let value = parseInt(this.inputTarget.value, 10)
    if (value < this.max ){
      this.inputTarget.value = value + 1
    }
  }

  decrement() {
    let value = parseInt(this.inputTarget.value, 10)
    if (value > 1) {
      this.inputTarget.value = value - 1
    }
  }
}